<template>
  <div id="wrapper">
    <router-view />
    <VToastGroup />
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import bus from "@/bus";
import VToastGroup from "./components/GlobalComponents/VToastGroup.vue";

const hideOverflow = ref(false);

watch(hideOverflow, (newValue) => {
  document.body.style.overflow = newValue ? "hidden" : "";
});

onMounted(() => {
  bus.$on("bodyOverflow", (state) => (hideOverflow.value = state));
});
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--grey-900);
}

@media (max-width: 760px) {
  div#mceu_20-body {
    display: none !important;
  }
}

.fadeInModal-enter-active,
.fadeInModal-leave-active {
  transition: all 0.2s ease;
}

.fadeInModal-enter-from {
  transform: translateY(-100px);
  opacity: 0;
}
.fadeInModal-leave-to {
  transform: translateY(100px);
  opacity: 0;
}

/*
  Animation test
 */

/* .post-loading-animation {
  -webkit-animation: fadein 2s;
  -moz-animation: fadein 2s;
  -ms-animation: fadein 2s;
  -o-animation: fadein 2s;
  animation: fadein 2s;
}

.exit-animation {
  -webkit-animation: fadeOut 0.5s;
  -moz-animation: fadeOut 0.5s;
  -ms-animation: fadeOut 0.5s;
  -o-animation: fadeOut 0.5s;
  animation: fadeOut 0.5s;
} */

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

/* Internet Explorer */
@-ms-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
